import { inject, Injectable } from '@angular/core'
import { createEffect } from '@ngrx/effects'
import { EMPTY, fromEvent } from 'rxjs'
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators'

import { ErrorHandlers } from '@app/services/error-handlers.service'

import { BadgesService } from '../services/badges.service'

@Injectable()
export class PwaEffects {
  private readonly badgesService = inject(BadgesService)

  private visibilityChange$ = fromEvent(document, 'visibilitychange').pipe(map(() => document.visibilityState))

  private readonly onHide$ = this.visibilityChange$.pipe(filter(visibilityState => visibilityState === 'hidden'))
  private readonly onShow$ = this.visibilityChange$.pipe(filter(visibilityState => visibilityState === 'visible'))

  readonly badge$ = createEffect(
    () =>
      this.badgesService.isEnabled()
        ? this.onHide$.pipe(
            switchMap(() => this.badgesService.sync()),
            tap(({ badge_count }) => this.badgesService.setAppBadge(badge_count)),
            catchError(error => {
              ErrorHandlers.handleError(error)
              return EMPTY
            }),
          )
        : EMPTY,
    { dispatch: false },
  )

  readonly clean$ = createEffect(() => this.onShow$.pipe(tap(() => this.badgesService.cleanBadges())), {
    dispatch: false,
  })

  constructor() {
    void this.badgesService.cleanBadges()
  }
}
